/**
 * Air-valve map marker assets and geometry.
 *
 * The marker artwork lives as static SVG files under /public (air-valve.svg,
 * air-valve-high-risk.svg) so the map layer (useAirValvesLayer, which rasterises them
 * via canvas for map.addImage) and the legend (SaviMapKeyCard, which renders them as an
 * <img>) share the exact same source — the legend can never drift from what is drawn on
 * the map.
 */

import { MAP_MARKER_HEIGHT, MAP_MARKER_WIDTH } from './markerDimensions';

/** Public path to the normal Air Valve marker (purple teardrop pin). */
export const AIR_VALVE_ICON_URL = '/air-valve.svg';

/** Public path to the High Risk Air Valve marker (red pin with a warning triangle). */
export const HIGH_RISK_AIR_VALVE_ICON_URL = '/air-valve-high-risk.svg';

/**
 * Rasterised marker dimensions (px) — the source SVGs' native size, shared with the POI markers
 * (see markerDimensions) so air valves and POIs render the same size on the map. Bottom-anchored
 * with a +6px icon-offset so the pin's point (6px above the canvas bottom) lands on the
 * coordinate (see useAirValvesLayer).
 */
export const AIR_VALVE_MARKER_WIDTH = MAP_MARKER_WIDTH;
export const AIR_VALVE_MARKER_HEIGHT = MAP_MARKER_HEIGHT;
